// Submit.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LexacquireTopnav from "./lexacquiretopnav";
import "./Submit.css";

export default function Submit() {
  const navigate = useNavigate();

  // Form fields state
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [industry, setIndustry] = useState("");
  const [category, setCategory] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [url, setUrl] = useState("");
  const [buzz, setBuzz] = useState("");
  const [overview, setOverview] = useState("");
  const [keyFeatures, setKeyFeatures] = useState("");
  const [useCases, setUseCases] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Utility to push the new agent into localStorage
  const saveToLocalStorage = (agentObject) => {
    try {
      const existing = localStorage.getItem("submittedAgents");
      let arr = [];
      if (existing) {
        arr = JSON.parse(existing);
        if (!Array.isArray(arr)) arr = [];
      }
      arr.push(agentObject);
      localStorage.setItem("submittedAgents", JSON.stringify(arr));
    } catch (e) {
      console.error("Failed to save to localStorage", e);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);

    // Basic validation
    if (!name.trim() || !description.trim()) {
      setError("Name and Description are required.");
      return;
    }

    setSubmitting(true);

    // Build a minimal agent object
    const newAgent = {
      id: `submitted-${Date.now()}`, // unique slug‐like ID
      name: name.trim(),
      description: description.trim(),
      industry: industry.trim(),
      category: category.trim(),
      logo: logoUrl.trim(),
      website_url: websiteUrl.trim(),
      url: url.trim(),
      buzz: buzz.trim(),
      overview: overview.trim(),
      key_features: keyFeatures
        .split("\n")
        .map((f) => f.trim())
        .filter((f) => f),
      use_cases: useCases
        .split("\n")
        .map((u) => u.trim())
        .filter((u) => u),
      viewCount: 0,
      voteCount: 0,
      reviewCount: 0,
      ratingAvg: null,
      trendingScore: null,
      featured: false,
      featuredOrder: 0,
      createdAt: new Date().toISOString(),
    };

    // Save it into localStorage
    saveToLocalStorage(newAgent);

    // Simulate slight delay (optional) and then navigate back or show success
    setTimeout(() => {
      setSubmitting(false);
      // Redirect to “Landscape” (for example), or wherever you list agents
      navigate("/lexacquire/landscape");
    }, 500);
  };

  return (
    <div className="submit-page">
      {/* ─── TOP NAV ─── */}
      <LexacquireTopnav />

      <div className="submit-container">
        {/* ─── PLATFORM METRICS CARD (Updated Icons + Blue CTA Button) ─── */}
        <div className="platform-metrics-card">
          <div className="metrics-header">
            <h3 className="metrics-title">Platform Metrics</h3>
            <div className="metrics-subtitle">
              <span className="status-live">● LIVE</span>
              <span className="timeframe">Last 30 days</span>
            </div>
          </div>

          <div className="metrics-items">
            {/* Page Views */}
            <div className="metric-item">
              <div className="metric-icon-wrapper icon-blue">
                {/* Eye icon, now blue */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#2563eb"
                  width="24px"
                  height="24px"
                >
                  <path d="M12 5c-7.633 0-12 7-12 7s4.367 7 12 7 12-7 12-7-4.367-7-12-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" />
                  <circle fill="#2563eb" cx="12" cy="12" r="2" />
                </svg>
              </div>
              <p className="metric-label">PAGE VIEWS</p>
              <p className="metric-value">410,000+</p>
            </div>

            {/* Outbound Clicks */}
            <div className="metric-item">
              <div className="metric-icon-wrapper icon-blue">
                {/* Arrow icon, now blue */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#2563eb"
                  width="24px"
                  height="24px"
                >
                  <path d="M12 2L10.59 3.41 17.17 10H2v2h15.17l-6.58 6.59L12 22l10-10z" />
                </svg>
              </div>
              <p className="metric-label">OUTBOUND CLICKS</p>
              <p className="metric-value">51,000+</p>
            </div>

            {/* Active Users */}
            <div className="metric-item">
              <div className="metric-icon-wrapper icon-blue">
                {/* Users icon, now blue */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#2563eb"
                  width="24px"
                  height="24px"
                >
                  <path d="M16 11c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm-8 0c1.657 0 3-1.343 3-3S9.657 5 8 5 5 6.343 5 8s1.343 3 3 3zm0 2c-2.33 0-7 1.167-7 3.5V19h14v-2.5C15 14.167 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                </svg>
              </div>
              <p className="metric-label">ACTIVE USERS</p>
              <p className="metric-value">102,000+</p>
            </div>
          </div>

          {/* CTA Banner */}

                <div className="metrics-cta-banner">
           <p className="cta-text">Want to maximize your visibility?</p>
           <button
             className="platform-metrics-cta-btn"
             onClick={() => navigate("/lexacquire/sponsorship")}
           >
             View Sponsorship Options →
           </button>
         </div>


        </div>
        {/* ───────────────────────────────────────────────────────────────── */}

        {/* ─── SUBMIT FORM SECTION ─── */}
        <h2>Submit Your AI Agent</h2>
        <p className="submit-subtitle">
          Fill out the form below to add your AI agent to Lexacquire. Once approved,
          it will appear on the main listing.
        </p>

        {error && <p className="submit-error">{error}</p>}

        <form className="submit-form" onSubmit={handleSubmit}>
          {/* Agent Name */}
          <label className="form-label">
            Agent Name<span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          {/* Short Description */}
          <label className="form-label">
            Short Description<span className="required">*</span>
          </label>
          <textarea
            className="form-textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
            required
          />

          {/* Industry */}
          <label className="form-label">Industry</label>
          <input
            type="text"
            className="form-input"
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
            placeholder="e.g. Finance, Healthcare, E-commerce…"
          />

          {/* Category */}
          <label className="form-label">Category</label>
          <input
            type="text"
            className="form-input"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder="e.g. Chatbot, Image Generation…"
          />

          {/* Logo URL */}
          <label className="form-label">Logo URL</label>
          <input
            type="url"
            className="form-input"
            value={logoUrl}
            onChange={(e) => setLogoUrl(e.target.value)}
            placeholder="https://…"
          />

          {/* Landing Page / SPA URL */}
          <label className="form-label">Landing Page URL</label>
          <input
            type="url"
            className="form-input"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://…"
          />

          {/* Official Website */}
          <label className="form-label">Official Website URL</label>
          <input
            type="url"
            className="form-input"
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
            placeholder="https://…"
          />

          {/* Buzz / Tag */}
          <label className="form-label">Buzz (e.g. “🔥 Trending”)</label>
          <input
            type="text"
            className="form-input"
            value={buzz}
            onChange={(e) => setBuzz(e.target.value)}
            placeholder="Optional"
          />

          {/* Overview */}
          <label className="form-label">Overview</label>
          <textarea
            className="form-textarea"
            value={overview}
            onChange={(e) => setOverview(e.target.value)}
            rows={4}
            placeholder="Provide a longer overview if desired"
          />

          {/* Key Features (one per line) */}
          <label className="form-label">Key Features (one per line)</label>
          <textarea
            className="form-textarea"
            value={keyFeatures}
            onChange={(e) => setKeyFeatures(e.target.value)}
            rows={3}
            placeholder="Feature 1\nFeature 2\n…"
          />

          {/* Use Cases (one per line) */}
          <label className="form-label">Use Cases (one per line)</label>
          <textarea
            className="form-textarea"
            value={useCases}
            onChange={(e) => setUseCases(e.target.value)}
            rows={3}
            placeholder="Use Case 1\nUse Case 2\n…"
          />

          <button
            type="submit"
            className="submit-btn"
            disabled={submitting}
          >
            {submitting ? "Submitting…" : "Submit Agent"}
          </button>
        </form>
      </div>
    </div>
  );
}
